// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2dJCy","overflowing":"ReadFullNote_overflowing__37ynB"};